/*global ViewController*/

const releaseNotesController = new ViewController({
    directory : "views/releaseNotes",
    name: "releaseNotes",
    route: "release-notes"
}) ;

releaseNotesController.prepareDataOnEnter = async function(){
    const notes = await this.apip.releaseNotes.list()||[] ;
    return {
        notes: notes,
        //the empty state is rendered instead of the list, a version can ship without any note
        hasNotes: notes.length > 0,
    } ;
} ;

module.exports = releaseNotesController ;
